



















import Vue from 'vue'

export interface Option {
  label: string
  value: any
}

export default Vue.extend({
  props: {
    columns: {
      // 一旦3と4しか使っていないが、tailwindの `w-1/n` クラスがあれば対応可能
      type: Number as () => 3 | 4,
      default: 3,
    },
    options: {
      type: Array as () => Option[],
      default: [],
    },
    values: {
      type: Array as () => Option['value'][],
      default: [],
    },
  },
  methods: {
    handleClick(value: Option['value']) {
      this.$emit(
        'onChange',
        this.values.includes(value)
          ? this.values.filter((v) => v !== value)
          : [...this.values, value]
      )
    },
  },
})
